module.exports = __webpack_public_path__ + "img/b67248f.jpg";